import React, { useState } from "react";
import { useAddress } from "@thirdweb-dev/react";
import { useTranslation } from "react-i18next";
import "../styles/vesting-box1.css";
import { useVestingContract } from "../hooks/useVestingContract";

const VestingBox1 = () => {
  const { t } = useTranslation();
  const address = useAddress();
  const { hasVesting, vestingInfo, isLoading } = useVestingContract();
  const [showInfoModal, setShowInfoModal] = useState(false);

  const formatAmountWithCommas = (amount) => {
    if (!amount) return "0";
    return parseFloat(amount).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  return (
    <div className="vesting-box">
      <div className="box-content">
        <div>
          <div className="header-container">
            <h4>{t('vestingBox1.yourVesting')}</h4>
            <img 
              src="/icons/info-icon-white.svg" 
              alt="Información" 
              className="info-icon"
              onClick={() => setShowInfoModal(true)}
            />
          </div>
          <p className="value">
            {!address ? "0" : isLoading ? t('vestingBox1.loading') : formatAmountWithCommas(vestingInfo.totalAmount)}
            <span className="unit green-text">$eDOP</span>
          </p>
        </div>
        <div>
          <h4>{t('vestingBox1.lockedTokens')}</h4>
          <p className="value">
            {!address ? "0" : isLoading ? t('vestingBox1.loading') : formatAmountWithCommas(vestingInfo.remainingAmount)}
            <span className="unit green-text">$eDOP</span>
          </p>
        </div>
      </div>
      
      <button id="view-details" disabled={!address || !hasVesting}>
        {t('vestingBox1.viewDetails')}
      </button>

      {/* Modal de información */}
      {showInfoModal && (
        <div className="info-modal-overlay" onClick={() => setShowInfoModal(false)}>
          <div className="info-modal" onClick={e => e.stopPropagation()}>
            <h3>{t('vestingBox1.infoModal.title')}</h3>
            <p>{t('vestingBox1.infoModal.content')}</p>
            <button onClick={() => setShowInfoModal(false)}>{t('vestingBox1.infoModal.understood')}</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default VestingBox1;
